// The API sends this code when it refuses the login itself: missing, expired or invalid token, or
// the account is gone (api/src/auth/jwt-auth.guard.ts). Any other 401, such as "Tutor access
// required", is a permission answer and must not log anyone out.
export const SESSION_INVALID = 'SESSION_INVALID';
export const SESSION_EXPIRED_EVENT = 'nova:session-expired';
export const SESSION_EXPIRED_MESSAGE = 'Your session has expired. Please log in again.';
export const SESSION_EXPIRED_LOGIN_PATH = '/login?session=expired';

export const isSessionRejection = (error) =>
  error?.response?.status === 401 && error.response.data?.code === SESSION_INVALID;
